<template>
  <div class="column">
        <!--

........................,,,,,.....................
....................,,;'+#######+:................
..................:;'+##';:::;+@@##'..............
.................;:'#: ';:,:':';''@##;............
................,.;..;,::;;'';,:;';'@#',..........
................,,`,..,:::;''';:;':;;##+,.........
................ .`.,,:::;+;;;::;;':;'##',........
...............`.`.`.,:,';'+;:++';+':;+##'........
.............. ``` ..;;';'++;:;;+:;;;;'+#+;.......
..............````,,;.:;'+';''+';'''':';##+,......
.............````..:.,''+;,'''++'+'+';;'+#++......
............, ``..,;:':';+;++;''';+;';;;'#+#:.....
............,```,``,:':''';'++''+++:;;:;++#++.....
............ `.````,.'++'''''''++#++;;';'+##+,....
...........' `. ..`++';;;;;;;;;;;:;+:';;'+##++....
...........# ` .``#',,,::::;;;:;::::;#+;';##++,...
....... ...;```. #;...,::;::;:;;:::,,,#,'+###+;...
.....``,:..,````#:```.,:;;;;;;;;::::,,,+;+###+'...
..... :`:,,`. .;'```,:;;';;;;;;;;;;;;:,;'+##+++:..
.....,.,:::`. `#` `:'++##+'';;'''+++++:,#'###++;..
....`:,,:::` `,;  ,'######+'';'++####++:'+###++'..
.... :.:,::`` #  `:'''''++++';'++++++##';#+#++++,.
...``:.:,::. `;  `.,'#@####'';:+##++':;';#+#+#++:.
...., ':,:::`+,  .,+#'##'##';:,+#'##+#::;+##++++;,
..`.`:;,,,:: ,.  ,':`''++++;;:,;++''''+:;'##+#++':
..`.`:::,,:: ,.  ,,,:'+++';;::,,;++';:::;'##+#+++;
.. ``:,;,,;:.,. `.,::;';';;;::,,,::::;:::'##+#+++;
..``,:,',,:::..  `.:;;;;;;;::::,:::::::,:'##+#+++'
.. .;:,:,;,,:.   `,;;;;;+;:::::,:::::::,:'##+#++++
.. .:,,.+'+,,,   `:;;;;''::;;;:,:'::::,,:'#@+#++++
.. `:`,,'#+;:;  `,;;;;'++'''''::,:':::,,:+#@+#++++
.. ,::,:,#++:;. `;''''++''#++'+#';+'::,,,+#@+#++++
.` `:+,:,,#;,:; .'''''+''''''';;;;'+':,,,+#@##++++
.` `:'.;';;,,::,:+++'++''''''';:::;'';:::+####++++
.  `:;+.,`;,,::;:++++++''''''';::::''':::+####++++
.  `,:#::,,:,,:;;+++++#+++#+++'::::';':::####+++++
.   ,,':,,,,,,,:;+++'++##+';:,:;'+#+;'::;@###+++++
.   ,:::,,,,,,,,;+++'+++++++'+'++;;'';::;@@##+#+++
.  `,::;,:,,,,,,,+++++++'''''';:,:::'::;;####+#++'
.  `,::',::,,,,,,'#++++++''''';:,:::';;;@#@##+#++;
.   .,:',:,,,,,,,:##++++++'''';;:::;;;;;@@@##+#++'
.`  `,:;,,,,,,,,::+##+++++++'';;:::;;;;@@@@##+#++'
.`  `,::::,,,,,,,:'##+++++'''';;;::;;;+@@@@##+##+;
..  `,::':::,,,,,,;.##+++'''';;::::;';@@@@#####++;
,,  `,::',:,,,,,,,:`:+;+++''';;:::;';@@@@@#@@##++'
:'  `,::;:::,,,,,,:``;';+++'';;:;;''+@@@@@#@@####'
'#  `,:::;::,,,,,,,.`.;;;#+++'';''''#@@@@@##@####'
'#   .::;+::::,,,:,:`.,;''+#++'+'''+@@@@@@##@####+
+#  `.:::':::::,,,:,:.,;'++##++'''++@@@@@@##@#+###
##  `,:;;;;;;;::,,,,,,,;'+++++''+++#@@@@@@@@@#####
## .,::;;;';;;;::,,:,::;'+++++'++++@@@@@@@@@@#####
@ `,:::;;'#';;;;::,,,,:;'++++++++++@@@@@@@#@######
``,::;;;''#+';;;;:::,,:;'+++++++++#@@@@@@@#@@#####
 ,::;;;;'++#@';;;:;:,,:,++++++++++@@@@@@@@@@@##+#+
.:::::;''#+##@;;::::::+###+++++++#@@@@@@@@@@@#####
,:::::'''##@@@+;:::;'#####++++++#@@@@@@@@@@@######
:::::;''#@@@@#@;;;;+########++++#@@@@@@@@@@@######
:;:::;''@@@@@##';;##########+++#@#@@@@@@@@@@######
@'::;''#@@@@@@@@;############+@@@@@@@@@@@@@@######
###;''+@@@@@@@#################@+@@@@@@@@@@@#####@
###@+'@@@@@@@@@##@####@##########@@@@@@@@@@@@@#@#@
##@#@#@@@@@@@@##@#@###@##########@@@@@@@@@@@@@@@@@
@@@@@@@@@@@@@#@@@@@@#@@@##########@@@@@@@@@@@@@@@@
@@@@@@@@@@@@@@@@@@@@@@@@@#########@@@@@@@@@@@@@@@@
@@@@@@@@@@@@@@@@@@@@@@@@@#@########+@@@@@@@@@@@@@@
@@@@@@@@@@@@@@@@@@@@@@@@@#@##########@@@@@@@@@@@#@
@@@@@@@@@@@@@@@@@@@@@@@@@##@#@######+@@@@@@@@@@@@@
~~~~~~***~~~~~PRAISE THIS CODE~~~~~~***~~~~~
-->
    <main class="wrap container-fluid">
      <div class="column center-xs middle-xs">
        <h1>Page not found</h1>
        <div>
          <img src="static/rösti.gif" class="floerin">
        </div>
        <router-link class="go-back" to="/">Go Back</router-link>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: 'fourzerofour',
};
</script>
<style lang="scss" scoped>
h1 {
  text-align: center;
  font-family: "Roboto Mono", monospace;
  margin-bottom: 10px;
  color: white;
}

.floerin {
  height: 50vh;
  margin: 20px;
  min-height: 200px;
}

.go-back {
  color: #f5f5f5;
  font-size: 20px;
  font-family: "Roboto Mono", monospace;
  text-transform: uppercase;
}
</style>




// WEBPACK FOOTER //
// src/components/404/404.vue